import React, { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { Telemetry } from '@videoblocks/kafka-rest-client';
import { AudioFileSearch } from '@videoblocks/react-icons';

import { legacyContentTypes as audioContentTypes } from '../../entities/AudioSearchFilterOptions';
import AudioFileSearchModal from '../modal/AudioFileSearchModal';

type SearchWithAudioButtonProps = {
  contentType: string;
  withLabel?: boolean;
};

const SearchWithAudioButton = ({
  contentType,
  withLabel = true,
}: SearchWithAudioButtonProps) => {
  const [isModalOpen, _setIsModalOpen] = useState(false);
  const showButton = audioContentTypes
    .map(({ value }) => value)
    .includes(contentType);

  const setIsModalOpen = React.useCallback((isOpen: boolean) => {
    _setIsModalOpen(isOpen);
    if (isOpen) void Telemetry.increment('search.bysound.click.init');
  }, []);

  if (!showButton) {
    return null;
  }

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className={twMerge(
          'hidden md:flex border-none whitespace-nowrap overflow-hidden justify-center py-6 rounded-full',
          withLabel && 'w-64 bg-yellow-400 hover:bg-yellow-50'
        )}
        title={!withLabel && 'Search with Audio Clip'}
      >
        <AudioFileSearch
          className={twMerge('w-6 h-6 mr-2', !withLabel && 'fill-gray')}
        />
        {withLabel && (
          <span className="text-gray-900 font-semibold">
            Search with Audio Clip
          </span>
        )}
      </button>
      <AudioFileSearchModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default SearchWithAudioButton;
